module.exports = __webpack_public_path__ + "res/img/icon-other.198f5630.png";